// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

import { SuspenseLoadingWrapper } from '@backoffice-frontend/patterns'
import { BoumRight } from '@moia-dev/moia-token-claims'
import { lazy } from 'react'
import { FleetTracingAreaId } from './FleetTracingAreaId'
import {
  FleetTracingAreaNavigation,
  FleetTracingAreaNavigationIcon,
} from './FleetTracingAreaNavigation'
import { FleetTracingAreaRoutes } from './FleetTracingAreaRoutes'

const LazyFleetTracingComponent = lazy(() => import('./FleetTracingArea'))

const FleetTracingComponent = () => (
  <SuspenseLoadingWrapper>
    <LazyFleetTracingComponent />
  </SuspenseLoadingWrapper>
)

export const FleetTracingArea = {
  id: FleetTracingAreaId,
  requiredRight: BoumRight.AREA_FETCH,
  Icon: FleetTracingAreaNavigationIcon,
  NavigationComponent: FleetTracingAreaNavigation,
  route: {
    path: FleetTracingAreaRoutes.route,
    component: FleetTracingComponent,
  },
}
